export default __webpack_public_path__ + "files/1fa0c18244a4b6d6ac8748c9a0dc9db4.png";